import React from 'react'

export function GamifieraBanner({ properties }) {
   const raw = properties?.identifier
   const className = typeof raw === 'string' ? raw.trim() : ''
   if (!className) return null

   return <div className={className} />
}
